import { render, staticRenderFns } from "./ContentInput.tts.player.vue?vue&type=template&id=37623308&"
import script from "./ContentInput.tts.player.vue?vue&type=script&lang=js&"
export * from "./ContentInput.tts.player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports